<!-- Order Shipment Page -->
@if (orderScreen === orderScreenEnums.Dashboard) {
  <div [className]="orderLineClass" [attr.cancelled]="orderShipment.allLinesAreCancelled"
    (click)="selectedOrder(orderShipment.orderNumber, orderShipment.shipmentNumber, orderShipment.sourceSystem)">
    <div class="flex-layout">
      <div class="flex-layout column item-grow order-line-left">
        <div class="order-name-number">
          <span class="order-name">{{orderShipment.customerName}}</span>
          <span class="order-text"> ({{orderShipment.customerNumber}})</span>
          @if (orderShipment.orderSourceSystem === dynamicsSourceSystem) {
            <mat-icon class="small-icon" title="Dynamics" aria-hidden="true">verified</mat-icon>
          }
        </div>
        <div class="flex-layout" style="row-gap: 0;">
          <div class="flex-layout" style="row-gap: 0;">
            <span class="order-text">Ships: <span [class]="shipDateClass">{{orderShipment.shipDate | date:'MM-dd-y'}} </span></span>
            <span class="order-text">Need: {{orderShipment.needDate | date:'MM-dd-y'}}</span>
            <span class="order-text">Order #: {{orderShipment.orderNumber}}:{{orderShipment.shipmentNumber}}</span>
          </div>
          @if (orderShipment.errors.length > 0) {
            <insight-order-issues [errors]="orderShipment.errors"></insight-order-issues>
          }
        </div>
      </div>
      <div>
        <mat-icon aria-hidden="false" title="{{ mediaIconTooltip }}" aria-label="">{{mediaIcon}}</mat-icon>
        @if (orderShipment.isOrderProcessing) {
          <mat-icon title="Currently Processing">offline_bolt</mat-icon>
        }
      </div>
    </div>
  </div>
}

<!-- Order Shipment Details Page (line item in board view) -->
@if (orderScreen === orderScreenEnums.Details) {
  <div [className]="orderLineClass">
    <div>
      <span class="order-name"><button class="link" (click)="linkToPubAdmin(orderLine.productNumber)">{{orderLine.title}}</button></span>
      <span class="item-grow"></span>
      @if (orderLine.isProcessing) {
        <mat-icon aria-hidden="false" aria-label="offline_bolt">offline_bolt</mat-icon>
      }
      @if (orderLine.isHd) {
        <mat-icon aria-hidden="false" aria-label="hd">hd</mat-icon>
      }
    </div>
    @if (orderShipment.orderType === orderTypeEnum.Adebs) {
      <div>
        <span>Version: {{orderLine.version}}</span>
      </div>
    }
    <div class="order-text-list">
      <span class="order-text">Line {{orderLine.lineNumber}}</span>
      <span class="order-text" [copyable]="orderLine.productNumber" copyLabel="product number">Product #: {{orderLine.productNumber}}</span>
      <!-- Cinelink only has one DRM type, so not much of a use to show it with that -->
      @if (orderLine.drmType && orderLine.drmType !== 'Cinelink') {
        <span class="order-text">DRM: {{orderLine.drmType}} </span>
      }
    </div>

    <insight-order-line-languages
      class="order-line-languages"
      [audioLanguages]="orderLine.audioLanguages"
      [subtitleLanguages]="orderLine.subtitleLanguages">
    </insight-order-line-languages>

    @if (orderLine.status === lineStatusEnums.Encrypting && orderLine.encryptStation && orderShipment.orderType === orderTypeEnum.Adebs) {
      <div>
        <span class="order-text">Encrypt Station: {{orderLine.encryptStation}}</span>
      </div>
    }
    <div class="flex-layout">
      @if (orderLine.errors.length > 0) {
        <insight-order-issues [errors]="orderLine.errors"></insight-order-issues>
      }
    </div>
  </div>
}
